import { render, staticRenderFns } from "./MessageFromAPI.vue?vue&type=template&id=dd2d5068&"
import script from "./MessageFromAPI.vue?vue&type=script&lang=js&"
export * from "./MessageFromAPI.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports